import { render } from "./MultiChoiceQuestion.vue?vue&type=template&id=05f790c7"
import script from "./MultiChoiceQuestion.vue?vue&type=script&lang=js"
export * from "./MultiChoiceQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__